import { QueryClient, QueryKey } from '@tanstack/react-query';

export function addToCache<T extends { id: string | number }>(
    newItems: T[],
    { queryClient, queryKey }: { queryClient: QueryClient; queryKey: QueryKey },
) {
    const existingCache = queryClient.getQueryData(queryKey);
    if (existingCache == null) return;

    queryClient.setQueryData<T[]>(queryKey, (cache) => {
        if (cache == null) return;
        return [...cache, ...newItems];
    });
}
